module.exports = __webpack_public_path__ + "img/nandu10-hvac-gray.16cb84d2.png";